module.exports = __webpack_public_path__ + "static/img/product-swipe45.4246ee08.png";